import React, { forwardRef, useImperativeHandle, useRef } from "react";
import classNames from "classnames";
import { Row } from "../../../../ts/UI";
import Cenik from "../../Cenik/Cenik";
import "./CennikPopup.scss";
import { CenikItem } from "../../../../ts/Cenik";
import { Polozka } from "../../../../ts/CP";

interface Props {
  active: boolean;
  onSelectItem?: (item: Polozka) => void;
}

const CennikPopup = ({ active, onSelectItem }: Props) => {
  if (!active) {
    return null;
  }

  return (
    <div className={classNames("cennik-popup", { active })}>
      <div className="cennik-list-title">Kliknutím vyberiete položku</div>
      <Cenik
        rowClickHandler={(row: CenikItem) => {
          onSelectItem?.({
            ...row,
            vyska: parseFloat(row.vyska),
            sirka: parseFloat(row.sirka),
            dph: 23,
            mn: 1,
          });
        }}
      />
    </div>
  );
};

export default CennikPopup;
